import { Button, ButtonGroup } from '@apollo/orbit';
import React from 'react';

import { CommunityRouter, DocsRouter, OdysseyRouter } from 'src/lib/routers';

export const ResourcesBar = () => {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-primary bg-primary">
      <ButtonGroup className="flex items-center justify-end px-4 py-1.5">
        <Button
          size="sm"
          as="a"
          href={DocsRouter.path('StudioHome')}
          target="_blank"
          rel="noopener noreferrer"
          variant="hidden"
        >
          Apollo Docs
        </Button>
        <Button
          size="sm"
          as="a"
          href={OdysseyRouter.path('Home')}
          target="_blank"
          rel="noopener noreferrer"
          variant="hidden"
        >
          Tutorials
        </Button>
        <Button
          size="sm"
          as="a"
          href={CommunityRouter.path('Home')}
          target="_blank"
          rel="noopener noreferrer"
          variant="hidden"
        >
          Community
        </Button>
      </ButtonGroup>
    </div>
  );
};
